export { default } from './PromoIntro';
